import { combineReducers } from 'redux';
import app from './appReducer';
import notification from './notificationReducer';

export default combineReducers({
  notification,
  app
});
